import { necrahInitParams, anginInitParams, barunaliInitParams, icikraInitParams, sanzinInitParams, tarkerInitParams } from "../tempDB";
import { Ally, IAllyBounty, IAllyBountyValue } from "./ally/Ally";

import bones from '../assets/img/bones.png'
import bonesWebp from '../assets/img/bones.webp'

// ? 
// necrah - Necrah_Blakahi - hp
// angin - Angin_Applemoon - int
// barunali - Barunali_Toldeth - str
// icikra - Icikra_Crurud - wis
// sanzin = Sanzin_Rosewood - con
// tarker - Tarker - dex
// ? 
// create allies
export const necrahAlly = new Ally(necrahInitParams)
export const anginAlly = new Ally(anginInitParams)
export const barunaliAlly = new Ally(barunaliInitParams)
export const icikraAlly = new Ally(icikraInitParams)
export const sanzinAlly = new Ally(sanzinInitParams)
export const tarkerAlly = new Ally(tarkerInitParams)

export const allies: Ally[] = [necrahAlly, anginAlly, barunaliAlly, icikraAlly, sanzinAlly, tarkerAlly]
//  for each set item
allies.forEach(ally => ally.setItemToLevelUp('bones', 'bones', { webp: bonesWebp, img: bones }))

function setNewBountyValue(ally: Ally) {
    let newBountyValue: IAllyBountyValue = {}

    for (let i = ally.getLevel().curruntLevel; i <= ally.getLevel().maxLevel; i++) {
        newBountyValue = {
            ...newBountyValue,
            [i]: i - 1
        }

        if (i === 40) {
            newBountyValue = {
                ...newBountyValue,
                [i]: i
            }
        }
    }

    return newBountyValue
}
// new bounte for each ally
const necrahBountyName: string = 'hp'
const necrahBountyValue: IAllyBountyValue = setNewBountyValue(necrahAlly)
const necrahBounty: IAllyBounty = { name: necrahBountyName, value: necrahBountyValue }
necrahAlly.setBounty(necrahBounty)

const anginBountyName: string = 'int'
const anginBountyValue: IAllyBountyValue = setNewBountyValue(anginAlly)
const anginBounty: IAllyBounty = { name: anginBountyName, value: anginBountyValue }
anginAlly.setBounty(anginBounty)

const barunaliBountyName: string = 'str'
const barunaliBountyValue: IAllyBountyValue = setNewBountyValue(barunaliAlly)
const barunaliBounty: IAllyBounty = { name: barunaliBountyName, value: barunaliBountyValue }
barunaliAlly.setBounty(barunaliBounty)

const icikraBountyName: string = 'wis'
const icikraBountyValue: IAllyBountyValue = setNewBountyValue(icikraAlly)
const icikraBounty: IAllyBounty = { name: icikraBountyName, value: icikraBountyValue }
icikraAlly.setBounty(icikraBounty)

const sanzinBountyName: string = 'con'
const sanzinBountyValue: IAllyBountyValue = setNewBountyValue(sanzinAlly)
const sanzinBounty: IAllyBounty = { name: sanzinBountyName, value: sanzinBountyValue }
sanzinAlly.setBounty(sanzinBounty)

const tarkerBountyName: string = 'dex'
const tarkerBountyValue: IAllyBountyValue = setNewBountyValue(tarkerAlly)
const tarkerBounty: IAllyBounty = { name: tarkerBountyName, value: tarkerBountyValue }
tarkerAlly.setBounty(tarkerBounty)

